/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_reinsurances_return = /** @type {(inputs: {}) => string} */ () => {
	return `Doprava a vrácení`
};

const da_reinsurances_return = /** @type {(inputs: {}) => string} */ () => {
	return `Levering og retur`
};

const de_reinsurances_return = /** @type {(inputs: {}) => string} */ () => {
	return `Versand und Rückgabe`
};

const en_reinsurances_return = /** @type {(inputs: {}) => string} */ () => {
	return `Delivery and return`
};

const es_reinsurances_return = /** @type {(inputs: {}) => string} */ () => {
	return `Envío y devolución`
};

const fr_reinsurances_return = /** @type {(inputs: {}) => string} */ () => {
	return `Livraison et retour`
};

const hu_reinsurances_return = /** @type {(inputs: {}) => string} */ () => {
	return `Szállítás és visszaküldés`
};

const it_reinsurances_return = /** @type {(inputs: {}) => string} */ () => {
	return `Spedizione e reso`
};

const nl_reinsurances_return = /** @type {(inputs: {}) => string} */ () => {
	return `Levering en retour`
};

const pl_reinsurances_return = /** @type {(inputs: {}) => string} */ () => {
	return `Wysyłka i zwrot`
};

const pt_reinsurances_return = /** @type {(inputs: {}) => string} */ () => {
	return `Entrega e devolução`
};

const sv_reinsurances_return = /** @type {(inputs: {}) => string} */ () => {
	return `Leverans och retur`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const reinsurances_return = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.reinsurances_return(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("reinsurances_return", locale)
	if (locale === "cs") return cs_reinsurances_return(inputs)
	if (locale === "da") return da_reinsurances_return(inputs)
	if (locale === "de") return de_reinsurances_return(inputs)
	if (locale === "en") return en_reinsurances_return(inputs)
	if (locale === "es") return es_reinsurances_return(inputs)
	if (locale === "fr") return fr_reinsurances_return(inputs)
	if (locale === "hu") return hu_reinsurances_return(inputs)
	if (locale === "it") return it_reinsurances_return(inputs)
	if (locale === "nl") return nl_reinsurances_return(inputs)
	if (locale === "pl") return pl_reinsurances_return(inputs)
	if (locale === "pt") return pt_reinsurances_return(inputs)
	return sv_reinsurances_return(inputs)
};
export { reinsurances_return as "reinsurances.return" }